import { http } from 'lib/api/http';

export async function fetchVehicleMakers() {
  const { data } = await http.get('/v1/vehicle-tree/maker');
  return Array.isArray(data) ? data : [];
}

export async function fetchVehicleLines(makerId) {
  const { data } = await http.get('/v1/vehicle-tree/line', {
    params: { makerId },
  });
  return Array.isArray(data) ? data : [];
}

export async function fetchConfigurationsForLine(makerId, lineId) {
  const { data } = await http.get('/v1/vehicle-tree/configuration', {
    params: { makerId, lineId },
  });
  return Array.isArray(data) ? data : [];
}

export async function fetchConfigurationsForYear(makerId, lineId, year) {
  const { data } = await http.get('/v1/vehicle-tree/configuration', {
    params: { makerId, lineId, year },
  });
  return Array.isArray(data) ? data : [];
}

export async function searchVehicleByLpn(licensePlateNumber) {
  const { data } = await http.get(
    `/v1/search-vehicle/${encodeURIComponent(licensePlateNumber)}`,
  );
  return data;
}

export function buildCatalogueIframeUrl(oemUrl) {
  const backUrl = `${window.location.origin}/catalog-part/{item_id}`;
  return `${oemUrl}?back_url_id=${backUrl}`;
}
